import { render, staticRenderFns } from "./PageHeaderV2.vue?vue&type=template&id=5ad4561b&scoped=true&"
import script from "./PageHeaderV2.vue?vue&type=script&lang=js&"
export * from "./PageHeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderV2.vue?vue&type=style&index=0&id=5ad4561b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad4561b",
  null
  
)

export default component.exports